"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var echarts = _interopRequireWildcard(require("echarts"));
var _bi = require("@/api/bi");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 引入ECharts
// 引入封装的API（核心修改）
var _default = exports.default = {
  name: 'LeaseDashboard',
  data: function data() {
    return {
      // 切换标签
      tabs: [{
        key: 'day',
        name: '按日'
      }, {
        key: 'month',
        name: '按月'
      }, {
        key: 'quarter',
        name: '按季'
      }, {
        key: 'year',
        name: '按年'
      }],
      activeTab: 'day',
      // 统计数据
      stats: {
        totalOrder: 0,
        totalIncome: 0,
        totalDeposit: 0,
        overdueOrder: 0
      },
      // 图表实例
      trendChart: null,
      statusChart: null,
      payMethodChart: null,
      // 动态数据
      trendData: {
        xAxis: [],
        orderTrend: []
      },
      statusData: [],
      payMethodData: [],
      latestOrders: []
    };
  },
  mounted: function mounted() {
    // 初始化数据和图表
    this.switchTab(this.activeTab);
  },
  methods: {
    // 格式化数字（保留两位小数）
    formatNumber: function formatNumber(num) {
      if (!num) return '0.00';
      return Number(num).toFixed(2);
    },
    // 切换数据维度
    switchTab: function () {
      var _switchTab = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(tabKey) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.activeTab = tabKey;
              // 加载数据
              _context.next = 3;
              return this.loadDashboardData(tabKey);
            case 3:
              // 初始化/更新图表
              this.initCharts();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function switchTab(_x) {
        return _switchTab.apply(this, arguments);
      }
      return switchTab;
    }(),
    // 加载看板数据（核心修改：使用封装的API）
    loadDashboardData: function () {
      var _loadDashboardData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(timeType) {
        var response, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _bi.getLeaseDashboardData)(timeType);
            case 3:
              response = _context2.sent;
              // 适配后端CommonResult返回格式（假设code=200为成功）
              data = response; // 更新统计数据
              this.stats = {
                totalOrder: data.stats.totalOrder || 0,
                totalIncome: data.stats.totalIncome || 0,
                totalDeposit: data.stats.totalDeposit || 0,
                overdueOrder: data.stats.overdueOrder || 0
              };
              // 更新趋势数据
              this.trendData = data.trendData || {
                xAxis: [],
                orderTrend: []
              };
              // 更新状态分布
              this.statusData = data.statusData || [];
              // 更新支付方式占比
              this.payMethodData = data.payMethodData || [];
              // 更新最新订单
              this.latestOrders = data.latestOrders || [];
              _context2.next = 16;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              console.error('加载租赁看板数据失败：', _context2.t0);
              // 加载失败时重置默认数据
              this.resetDefaultData();
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 12]]);
      }));
      function loadDashboardData(_x2) {
        return _loadDashboardData.apply(this, arguments);
      }
      return loadDashboardData;
    }(),
    // 重置默认数据（兜底）
    resetDefaultData: function resetDefaultData() {
      this.stats = {
        totalOrder: 0,
        totalIncome: 0,
        totalDeposit: 0,
        overdueOrder: 0
      };
      this.trendData = {
        xAxis: [],
        orderTrend: []
      };
      this.statusData = [];
      this.payMethodData = [];
      this.latestOrders = [];
    },
    // 初始化所有图表
    initCharts: function initCharts() {
      // 订单趋势图
      this.initTrendChart();
      // 订单状态分布图
      this.initStatusChart();
      // 支付方式占比图
      this.initPayMethodChart();
    },
    // 初始化订单趋势图（折线图）
    initTrendChart: function initTrendChart() {
      var _this = this;
      if (this.trendChart) {
        this.trendChart.dispose();
      }
      this.trendChart = echarts.init(this.$refs.trendChart);
      this.trendChart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: '{b}: {c} 单'
        },
        xAxis: {
          type: 'category',
          data: this.trendData.xAxis || []
        },
        yAxis: {
          type: 'value',
          name: '订单数'
        },
        series: [{
          name: '租赁订单',
          type: 'line',
          data: this.trendData.orderTrend.map(function (item) {
            return Number(item);
          }) || [],
          smooth: true,
          itemStyle: {
            color: '#409EFF'
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: 'rgba(64, 158, 255, 0.8)'
              }, {
                offset: 1,
                color: 'rgba(64, 158, 255, 0.1)'
              }]
            }
          }
        }],
        grid: {
          left: '10%',
          right: '5%',
          bottom: '10%',
          top: '10%'
        }
      });

      // 自适应窗口大小
      window.addEventListener('resize', function () {
        _this.trendChart.resize();
      });
    },
    // 初始化订单状态分布图（饼图）
    initStatusChart: function initStatusChart() {
      var _this2 = this;
      if (this.statusChart) {
        this.statusChart.dispose();
      }
      this.statusChart = echarts.init(this.$refs.statusChart);
      this.statusChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        series: [{
          name: '订单状态',
          type: 'pie',
          radius: ['40%', '70%'],
          data: this.statusData || '暂无数据',
          label: {
            show: true,
            formatter: '{b}: {c} ({d}%)'
          },
          itemStyle: {
            color: function color(params) {
              var colorList = ['#E6A23C', '#67C23A', '#F56C6C'];
              return colorList[params.dataIndex] || '#909399';
            }
          }
        }]
      });
      window.addEventListener('resize', function () {
        _this2.statusChart.resize();
      });
    },
    // 初始化支付方式占比图（环形图）
    initPayMethodChart: function initPayMethodChart() {
      var _this3 = this;
      if (this.payMethodChart) {
        this.payMethodChart.dispose();
      }
      this.payMethodChart = echarts.init(this.$refs.payMethodChart);
      this.payMethodChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        series: [{
          name: '支付方式',
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['50%', '50%'],
          data: this.payMethodData || [],
          label: {
            show: true,
            formatter: '{b}: {d}%'
          },
          itemStyle: {
            color: function color(params) {
              var colorList = ['#409EFF', '#909399'];
              return colorList[params.dataIndex] || '#C0C4CC';
            }
          }
        }]
      });
      window.addEventListener('resize', function () {
        _this3.payMethodChart.resize();
      });
    },
    // 获取订单状态文本
    getStatusText: function getStatusText(status) {
      switch (Number(status)) {
        case 0:
          return '待取货';
        case 1:
          return '待归还';
        case 2:
          return '已归还';
        default:
          return '未知状态';
      }
    },
    // 获取订单状态样式类
    getStatusClass: function getStatusClass(status) {
      switch (Number(status)) {
        case 0:
          return 'pending-pick';
        case 1:
          return 'pending-return';
        case 2:
          return 'returned';
        default:
          return '';
      }
    }
  },
  // 组件销毁时释放图表资源
  beforeDestroy: function beforeDestroy() {
    if (this.trendChart) this.trendChart.dispose();
    if (this.statusChart) this.statusChart.dispose();
    if (this.payMethodChart) this.payMethodChart.dispose();
  }
};